import React from 'react';

/**
 * Premium Vault Logo — shield/vault shape with a "V" and dial dot.
 * Renders as inline SVG for crispness at any size.
 */
const Logo = ({ size = 22, showText = true, textSize = 13, className = '' }) => {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Premium Vault"
      >
        {/* Outer shield */}
        <path
          d="M20 2 L34 7 V19 C34 27.5 28 34.5 20 37 C12 34.5 6 27.5 6 19 V7 Z"
          fill="#0f1a12"
          stroke="#22c55e"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        {/* Inner accent line */}
        <path
          d="M20 5.5 L31 9.5 V18.5 C31 25.5 26 31 20 33 C14 31 9 25.5 9 18.5 V9.5 Z"
          stroke="#22c55e"
          strokeOpacity="0.35"
          strokeWidth="0.8"
          fill="none"
        />
        {/* Vault dial dot at top */}
        <circle cx="20" cy="10.5" r="1.6" fill="#22c55e" />
        {/* V mark */}
        <path
          d="M12.5 16 L20 27 L27.5 16"
          stroke="#22c55e"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {showText && (
        <span
          className="tracking-[0.22em] text-[#e6e6e6] font-mono"
          style={{ fontSize: textSize }}
        >
          PREMIUM VAULT
        </span>
      )}
    </span>
  );
};

export const LogoMark = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 2 L34 7 V19 C34 27.5 28 34.5 20 37 C12 34.5 6 27.5 6 19 V7 Z"
      fill="#0f1a12"
      stroke="#22c55e"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="20" cy="10.5" r="1.6" fill="#22c55e" />
    <path
      d="M12.5 16 L20 27 L27.5 16"
      stroke="#22c55e"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Logo;
